import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DIREZIONE_TRASFERIMENTO, Ordine, STATO_ORDINE, STATO_TRASFERIMENTO, TIPO_ORDINE} from "../../../models/Ordine";
import {ActivatedRoute, Router} from "@angular/router";
import {DxService} from "../../../services/dx.service";
import {DialogService} from "../dialog/dialog.service";
import {PvenditaComponent} from "../../../pages/root/esercizio/pvendita/pvendita.component";
import {ServerService} from "../../../services/server.service";
import {DxDataGridComponent} from "devextreme-angular";

@Component({
   selector: 'app-tab-trasferimenti',
   templateUrl: './tab-trasferimenti.component.html',
   styleUrls: ['./tab-trasferimenti.component.scss']
})
export class TabTrasferimentiComponent implements OnInit {
   @ViewChild('grid') grid!:DxDataGridComponent

   @Input() vendorSlug;
   @Input() pVenditaId;
   @Input() dir;

   Ordine = Ordine;
   STATO_TRASFERIMENTO = STATO_TRASFERIMENTO;
   DIREZIONE_TRASFERIMENTO = DIREZIONE_TRASFERIMENTO;
   headerFilterStatoData: any;
   headerFilterTrasfData: any;
   STATO_ORDINE = STATO_ORDINE;

   constructor(private router: Router,
               private dxSrv: DxService,
               private route: ActivatedRoute,
               private dialogSrv: DialogService,
               private pVenditaCom: PvenditaComponent,
               private serverSrv: ServerService) {
      this.headerFilterTrasfData = Ordine.HeaderFilterStatoTrasferimentoData
      this.headerFilterStatoData = Ordine.HeaderFilterStatoData

      this.headerFilterStatoData.push(
            {
         text: "Confermato",
         value: STATO_ORDINE.CONFERMATO
      },)
   }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.initGrid()
      console.log(this.pVenditaId)
   }

   initGrid(){
      this.dxSrv.initGrid(this.grid, {showAdd:this.dir == DIREZIONE_TRASFERIMENTO.USCITA, onClickNew:() =>{
            // this.router.navigate(['new'], {relativeTo: this.route})
            this.clickCreateNewTrasferimento()
         }})
      this.dxSrv.gridCreateDataSource(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/trasferimenti?dir=${this.dir}`, this.grid)
   }

   clickCreateNewTrasferimento() {
      this.serverSrv.post(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/trasferimenti`, {tipo:TIPO_ORDINE.TRASFERIMENTO}, Ordine).then(res => {
         this.router.navigate(['../'+res.data.id], {relativeTo:this.route})
         this.dialogSrv.showToastSuccess({title:"Nuovo trasferimento", msg:"Nuovo trasferimento creato"})
         console.log(res)
      }).catch(err => {
         console.error(err)
      })
   }

   clickEliminaTrasferimento(id){
      this.dialogSrv.showConfirm({title:"Elimina trasferimento", msg:"Vuoi eliminare questo trasferimento?"}).then(() => {
         this.serverSrv.delete(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/trasferimenti/${id}`, {}, null).then(res => {
            this.dialogSrv.showSuccess({title:"Elimina trasferimento", msg:"Trasferimento eliminato"})
            this.grid.instance.refresh()
         }).catch(err => {
            this.dialogSrv.showError({title:"Attenzione!", err:err})
            console.error(err)
         })
      }).catch(err => {})
   }

   clickScaricaDdt(ddt: any) {
      const a:any = document.createElement('a')
      a.href = ddt
      a.download = `${ddt}`.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
   }

}
